import * as tslib_1 from "tslib";
import { lazyInitializeExtensibilityContext } from 'owa-addins-core';
import { isMailFeatureEnabled } from 'owa-mail-feature-flags';
export default function initializeExtensibilityContext() {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isMailFeatureEnabled('rp-addins')) {
                        return [2 /*return*/];
                    }
                    return [4 /*yield*/, lazyInitializeExtensibilityContext.import()];
                case 1:
                    (_a.sent())();
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=initializeExtensibilityContext.js.map